module.exports = __webpack_public_path__ + "img/u4821.054d7bf2.svg";